module.exports = __webpack_public_path__ + "static/media/song4.403350e6.mp3";